import { Container, Dialog, Heading } from "@/components"
import useEditPlan from "./useEditPlan";
import { Button, Textarea } from "@/components/ui";
import { PreviewPlan } from "./PreviewPlan";

const EditPlan = () => {
  const {
    breadcrumbData,
    showConfirmation,
    setShowConfirmation,
    onConfirmSubmit,
    onSubmitApproval,
    reason,
    onChangeReason,
    isUpdatePending,
    isPlanLoading,
    isApprovePlanExist,
    isApproveClicked,
    onViewHierarchy,
    onViewTaskPlan
  } = useEditPlan();

  return (
    <Container>
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={breadcrumbData[breadcrumbData.length - 1]?.name || ''} breadcrumbData={breadcrumbData} />
        </div>
        <div className="flex flex-row items-center gap-3">
          {isPlanLoading || isApprovePlanExist ? <></> :
            <>
              <Button onClick={onSubmitApproval(true)} disabled={isUpdatePending} className="bg-green-600 text-white hover:text-white hover:bg-green-600">
                Approve
              </Button>
              <Button onClick={onSubmitApproval(false)} disabled={isUpdatePending} className="bg-red-600 text-white hover:text-white hover:bg-red-600">
                Reject
              </Button>
            </>
          }
          <Button onClick={onViewHierarchy}>View Task Hierarchy</Button>
          <Button onClick={onViewTaskPlan}>View Task Plan</Button>
        </div>
      </div>

      <PreviewPlan />

      <Dialog
        open={showConfirmation}
        setOpen={setShowConfirmation}
        title="Submit For Approval?" 
        onSave={onConfirmSubmit}
        saveText="Submit"
        contentClassName="lg:!max-w-[500px] lg:w-[500px]"
        isLoading={isUpdatePending}
      >
        <div>
          Are you sure you want to {isApproveClicked.current ? 'approve' : 'reject'} this project plan?<br/>
          If yes, please provide a brief reason for your {isApproveClicked.current ? 'approval' : 'rejection'} below.
          <div className="mt-5">
            <Textarea value={reason} onChange={onChangeReason} placeholder="Enter your reason here" className="h-[300px]" />
          </div>
        </div>
      </Dialog>
    </Container>
  )
}

export default EditPlan;